import images from "./images";

var resource = {
    images
}
export default resource